import uuid from 'uuid';
import type { LocalIssueId } from '@atlassian/jira-polaris-domain-idea/src/idea/types.tsx';

export const generateLocalIssueId = (): LocalIssueId => uuid();
export const generateLocalExternalIssueId = (): LocalIssueId => uuid();
